import { z } from 'zod';

import {
  zodContractActionMetadataSchema,
  zodContractActionSchema,
} from '../validations';

// Re-export shared validations used by this hook
export { zodContractActionMetadataSchema, zodContractActionSchema };

// Contract actions response schema (GET /contracts/{id}/actions)
export const zodContractActionsResponseSchema = z.object({
  actionsMetadata: z.array(zodContractActionMetadataSchema),
  availableActions: z.array(zodContractActionSchema),
});
